export default "__VITE_ASSET__BQNYmFQo__"